import gql from 'graphql-tag';

export default gql`
    query GetEmptyBoxes($jobId: Int) {
        getEmptyBoxes(jobId: $jobId) {
            emptyBoxDetails {
                boxId
                boxDesc
            }
        }
    }
`;
